import * as React from 'react';
import { GridLine, GridLineClassNames } from './GridLine';
import { ItemsLayout } from '../interfaces/ItemsLayout';
import { SurfaceStore } from 'owa-calendar-surface-core';
import GridLinesFragment from './GridLinesFragment';

/** Renders the set of grid lines, containing the solid or dashed lines. */
export function GridLines(props: {
    store: SurfaceStore;
    itemsLayout: ItemsLayout;
    increment: number;
    classNames?: GridLineClassNames;
}) {
    return (
        <GridLinesFragment
            itemType={GridLine}
            itemClassNames={props.classNames}
            itemsLayout={props.itemsLayout}
            intervalInMinutes={props.increment}
            store={props.store}
            showIsNewDay={false}
        />
    );
}
